import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSEO } from '../../hooks/useSEO';
import { buildBreadcrumbJsonLd } from '../../config/seo';
import ContactForm from '../../components/ContactForm/ContactForm';
import BlobDecoration from '../../components/BlobDecoration/BlobDecoration';
import SocialLinks from '../../components/SocialLinks/SocialLinks';
import { Language } from '../../routes/routeConfig';
import styles from './Contact.module.css';

const Contact: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const preselectedService = searchParams.get('service') || undefined;

  const seo = useSEO({
    titleKey: 'seo.contact.title',
    descriptionKey: 'seo.contact.description',
    routeKey: 'contact',
    structuredData: buildBreadcrumbJsonLd(
      [
        { name: t('nav.home'), routeKey: 'home' },
        { name: t('nav.contact'), routeKey: 'contact' },
      ],
      i18n.language as Language
    ),
  });

  return (
    <div className={styles.contact}>
      {seo}
      <section className={styles.header}>
        <BlobDecoration color="red" position="top-left" size="md" />
        <BlobDecoration color="blue" position="top-right" size="sm" />
        <div className="container">
          <h1 className={styles.pageTitle}>{t('contact.pageTitle')}</h1>
          <p className={styles.pageSubtitle}>{t('contact.pageSubtitle')}</p>
        </div>
      </section>

      <section className={styles.contentSection}>
        <div className={`container ${styles.grid}`}>
          <div className={styles.formColumn}>
            <ContactForm preselectedService={preselectedService} />
          </div>
          <div className={styles.infoColumn}>
            <h3 className={styles.infoTitle}>{t('contact.infoTitle')}</h3>
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>{t('contact.email')}</span>
              <a href="mailto:hello@chipet.app" className={styles.infoLink}>
                hello@chipet.app
              </a>
            </div>
            <div className={styles.infoItem}>
              <span className={styles.infoLabel}>{t('contact.phone')}</span>
              <a href="tel:+36303017733" className={styles.infoLink}>
                +36 30 301 7733
              </a>
            </div>
            <SocialLinks />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
